import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { eamApi } from "@/api/eamApi";
import { REM_CONFIG } from "@/utils/fontSize";
const AssetStatus = ({ className = "" }) => {
    const [chartData, setChartData] = useState([]);
    const name = chartData.map((item) => item.cname) || [];
    const count = chartData.map((item) => item.count) || [];
    const amount = chartData.map((item) => item.amount) || [];
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await eamApi.status();
            setChartData(res.data);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    const getEchartsOption = () => ({
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        legend: {
            show: true, // 启用图例
            data: ["金额", "数量"], // 必须与 series.name 一一对应
            textStyle: { color: "#ffffff", fontSize: REM_CONFIG.fontSize.small }, // 文字颜色适配深色背景
            top: 0, // 距离顶部的距离（可调整）
            right: "center",
            orient: "horizontal",
        },
        xAxis: {
            type: "category",
            data: name,
            axisLabel: { color: "#ffffff", interval: 0 },
            splitLine: { show: false }, // 隐藏垂直网格线
            // 显示 X 轴轴线（底部横线）
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,0.5)", // 半透明白色
                    width: 1,
                },
            },
        },
        yAxis: [
            {
                type: "value",
                name: "金额（万元）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLabel: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                    interval: 0,
                    formatter: (value) => {
                        return (value / 10000);
                    },
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 网格线浅灰透明
                },
            },
            {
                type: "value",
                name: "数量（项）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                    textShadowColor: "rgba(0,0,0,0.3)", // 文字阴影颜色
                    textShadowBlur: 2, // 模糊程度
                },
                axisLabel: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{value}",
                },
                position: "right",
                splitLine: { show: false },
            },
        ],
        series: [
            {
                name: "金额",
                type: "line",
                data: amount,
                itemStyle: { color: "#4189FD" },
                lineStyle: { color: "#4189FD" },
                yAxisIndex: 0,
            },
            {
                name: "数量",
                type: "line",
                data: count,
                itemStyle: { color: "#61D7EF" },
                lineStyle: { color: "#61D7EF" },
                yAxisIndex: 1,
                areaStyle: {
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: "rgba(97, 215, 239, 0.3)" },
                            { offset: 1, color: "rgba(97, 215, 239, 0)" },
                        ],
                    },
                },
            },
        ],
        grid: {
            left: "6%",
            right: "6%",
            bottom: "6%",
            top: "20%",
            containLabel: true,
        },
    });
    return (_jsxs("div", { className: `relative bg-gradient-to-t from-[rgba(7,31,75,0.5)] to-[rgba(6,32,66,0.5)]  flex flex-col ${className}`, children: [_jsx(ModuleHeader, { title: "\u8D44\u4EA7\u72B6\u6001\u7EDF\u8BA1" }), _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { option: getEchartsOption(), style: { width: "100%", height: "100%" } }) })] }));
};
export default AssetStatus;
